











import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  name: 'Dialog'
})
export default class extends Vue {
  @Prop() private dialog!: {
    isDeleVisible:boolean
  }
  // 功能函数
  // 表单提交
  private handleSubmit() {
    this.$emit('state-submit')
  }

  // 表单取消
  private handleClose() {
    this.$emit('handle-close')
  }
}
